// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.proyectsToActivate-container {
    width: 100%;
    margin: 0;
    max-height: 90vh;
    overflow-y: scroll;
}

.proyectsToActivate-container .noProyectsToActive {
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}

.proyectsToActivate-container > div {
    background-color: #0e0f15;
    border: 3px solid #f09502;
}

.proyectsToActivate-container img {
    max-width: 30%;
    height: auto;
}

.valuesProyectToActivate {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}

.valuesProyectToActivate > div {
    padding-left: 15px;
}

.proyectsToActivate-container .resaltar {
    font-weight: bold;
    color: #f09502;
}

.proyectsToActivate-container .accordion-header buttom {
    background-color: #0e0f15 !important;
}

.proyectsToActivate-container .buttonsDatActivate {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex-wrap: wrap;
}

.proyectsToActivate-container .buttonsDatActivate .btn {
    display: block;
    margin-left: 15px;
}

.errorInput {
    background-color: rgb(255, 196, 196);
}`, "",{"version":3,"sources":["webpack://./src/app/components/new-sale-seller/new-sale-seller.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[":host {\n    width: 100%;\n}\n\n.proyectsToActivate-container {\n    width: 100%;\n    margin: 0;\n    max-height: 90vh;\n    overflow-y: scroll;\n}\n\n.proyectsToActivate-container .noProyectsToActive {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n}\n\n.proyectsToActivate-container > div {\n    background-color: #0e0f15;\n    border: 3px solid #f09502;\n}\n\n.proyectsToActivate-container img {\n    max-width: 30%;\n    height: auto;\n}\n\n.valuesProyectToActivate {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.valuesProyectToActivate > div {\n    padding-left: 15px;\n}\n\n.proyectsToActivate-container .resaltar {\n    font-weight: bold;\n    color: #f09502;\n}\n\n.proyectsToActivate-container .accordion-header buttom {\n    background-color: #0e0f15 !important;\n}\n\n.proyectsToActivate-container .buttonsDatActivate {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.proyectsToActivate-container .buttonsDatActivate .btn {\n    display: block;\n    margin-left: 15px;\n}\n\n.errorInput {\n    background-color: rgb(255, 196, 196);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
